import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from 'recharts'

import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment,
} from 'semantic-ui-react'

import Top from './Top';
import Footer from './Footer';
import TestList from './TestList';
import TestButton from './TestButton';
import TestMathjax from './TestMathjax';
import TestContent01 from './TestContent01';
import TestKatexExamples from './TestKatexExamples';

import Chapter100 from './components/chapter1/0'
import Chapter101 from './components/chapter1/1'
import Chapter102 from './components/chapter1/2'
import Chapter103 from './components/chapter1/3'
import Chapter104 from './components/chapter1/4'
import Chapter105 from './components/chapter1/5'
import Chapter106 from './components/chapter1/6'

import Chapter200 from './components/chapter2/0'
import Chapter201 from './components/chapter2/1'
import Chapter202 from './components/chapter2/2'
import Chapter203 from './components/chapter2/3'
import Chapter204 from './components/chapter2/4'
import Chapter205 from './components/chapter2/5'
import Chapter206 from './components/chapter2/6'

import Chapter300 from './components/chapter3/0'
import Chapter301 from './components/chapter3/1'

import Chapter400 from './components/chapter4/0'
import Chapter401 from './components/chapter4/1'
import Poisson from './components/chapter4/poisson'
import Binomial from './components/chapter4/binomial'
import Nbd from './components/chapter4/nbd'
import Norm from './components/chapter4/norm'
import Gamma from './components/chapter4/gamma'
import Geometric from './components/chapter4/geometric'

import Nbd01 from './components/graph/nbd'

import 'semantic-ui-css/semantic.min.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
    };

  }

  render() {

    return (
      <div>
        <Menu fixed='top' inverted>
          <Container  style={{"font-size":"150%"}}>
            <Menu.Item as='a' href='/'>Home</Menu.Item>

            <Dropdown item simple text='目次'>
              <Dropdown.Menu>
                <Dropdown.Item href='/chapter1/0'>
                  <i className='dropdown icon' />
                  <span className='text'>chapter1</span>
                  <Dropdown.Menu>
                    <Dropdown.Item href='/chapter1/0'>1 イントロダクション</Dropdown.Item>
                    <Dropdown.Item href='/chapter1/1'>1-1 二項分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter1/2'>1-2 ポアソン分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter1/3'>1-3 負の二項分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter1/4'>1-4 ポアソン分布と二項分布のまとめ</Dropdown.Item>
                    <Dropdown.Item href='/chapter1/5'>1-5 売り上げを支配する重要な式</Dropdown.Item>
                    <Dropdown.Item href='/chapter1/6'>1-6 デリシュレーNBDモデル</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown.Item>

                <Dropdown.Item href='/chapter2/0'>
                  <i className='dropdown icon' />
                  <span className='text'>chapter2</span>
                  <Dropdown.Menu>
                    <Dropdown.Item href='/chapter2/0'>2 イントロダクション</Dropdown.Item>
                    <Dropdown.Item href='/chapter2/1'>2-1 ガンマ・ポアソン・リーセンシー・モデル</Dropdown.Item>
                    <Dropdown.Item href='/chapter2/2'>2-2 負の二項分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter2/3'>2-3 カテゴリーの進出順位モデル</Dropdown.Item>
                    <Dropdown.Item href='/chapter2/4'>2-4 トライアルモデル・リピートモデル</Dropdown.Item>
                    <Dropdown.Item href='/chapter2/5'>2-5 平均購入額・量モデル (VPP Model: Volume per Purchase)</Dropdown.Item>
                    <Dropdown.Item href='/chapter2/6'>2-6 デリシュレーNBDモデル</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown.Item>

                <Dropdown.Item href='/chapter3/0'>
                  <i className='dropdown icon' />
                  <span className='text'>chapter3</span>
                  <Dropdown.Menu>
                    <Dropdown.Item href='/chapter3/0'>3 イントロダクション</Dropdown.Item>
                    <Dropdown.Item href='/chapter3/1'>3-1 Repeat Buying モデル</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown.Item>

                <Dropdown.Item href='/chapter4/0'>
                  <i className='dropdown icon' />
                  <span className='text'>chapter4</span>
                  <Dropdown.Menu>
                    <Dropdown.Item href='/chapter4/0'>4 イントロダクション</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/1'>4-1 確率分布の基礎</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/poisson'>4-2 ポアソン分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/binomial'>4-3 二項分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/nbd'>4-4 負の二項分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/norm'>4-5 正規分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/gamma'>4-6 ガンマ分布</Dropdown.Item>
                    <Dropdown.Item href='/chapter4/geometric'>4-7 幾何分布</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown.Item>

                <Dropdown.Divider />
                <Dropdown.Header>Header Item</Dropdown.Header>
                <Dropdown.Item href='/katex'>
                  <i className='dropdown icon' />
                  <span className='text'>katex</span>
                  <Dropdown.Menu>
                    <Dropdown.Item href='/katex'>example</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown.Item>
                <Dropdown.Item href='/mathjax'>mathjax exmaple</Dropdown.Item>
                <Dropdown.Item href='/nbd01'>nbd exmaple</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Container>
        </Menu>

        <Container text style={{ marginTop: '5em',"font-size":"110%" }}>
           <Router>
             <div>
               <Switch>
                 <Route exact path='/' component={Top}/>
                 <Route path='/chapter1/0' component={Chapter100}/>
                 <Route path='/chapter1/1' component={Chapter101}/>
                 <Route path='/chapter1/2' component={Chapter102}/>
                 <Route path='/chapter1/3' component={Chapter103}/>
                 <Route path='/chapter1/4' component={Chapter104}/>
                 <Route path='/chapter1/5' component={Chapter105}/>
                 <Route path='/chapter1/6' component={Chapter106}/>
                 <Route path='/chapter2/0' component={Chapter200}/>
                 <Route path='/chapter2/1' component={Chapter201}/>
                 <Route path='/chapter2/2' component={Chapter202}/>
                 <Route path='/chapter2/3' component={Chapter203}/>
                 <Route path='/chapter2/4' component={Chapter204}/>
                 <Route path='/chapter2/5' component={Chapter205}/>
                 <Route path='/chapter2/6' component={Chapter206}/>
                 <Route path='/chapter3/0' component={Chapter300}/>
                 <Route path='/chapter3/1' component={Chapter301}/>
                 <Route path='/chapter4/0' component={Chapter400}/>
                 <Route path='/chapter4/1' component={Chapter401}/>
                 <Route path='/chapter4/poisson' component={Poisson}/>
                 <Route path='/chapter4/binomial' component={Binomial}/>
                 <Route path='/chapter4/nbd' component={Nbd}/>
                 <Route path='/chapter4/norm' component={Norm}/>
                 <Route path='/chapter4/gamma' component={Gamma}/>
                 <Route path='/chapter4/geometric' component={Geometric}/>
                 <Route path='/katex' component={TestKatexExamples}/>
                 <Route path='/mathjax' component={TestMathjax}/>
                 <Route path='/nbd' component={Nbd01}/>
               </Switch>
             </div>
           </Router>
         </Container>

       <Segment inverted vertical style={{ margin: '2em 0em 0em', padding: '2em 0em' }}>
         <Container textAlign='center'>
           <List horizontal inverted divided link size='small'>
             <List.Item as='a' href='#'>
               <p style={{"font-size":"150%"}}>Site Map</p>
             </List.Item>
             <List.Item as='a' href='#'>
               <p style={{"font-size":"150%"}}>Privacy Policy</p>
             </List.Item>
           </List>
           <p style={{"font-size":"150%"}}>© 2019 Copyright: abc.com</p>
         </Container>
       </Segment>
     </div>
    )
  }
}

export default App;
